import React, { useState } from 'react';
import { Button } from '../../../../../ui';
import { TextInput } from '../../../../../ui/input/text_input/text_input';
import { UserRole } from '../../../../../utils/types/admin_types';
import styles from '../../modals.module.css';
import { SelectPermissions } from './select_permissions';

type EditRoleModalProps = {
  role: UserRole;
  entities: string[];
  editRole: (role: UserRole, roleName: string, permissions: string[]) => void;
};

const actions: string[] = ['create', 'edit', 'delete', 'view'];

function EditRoleModal({
  role,
  entities,
  editRole,
}: EditRoleModalProps): JSX.Element {
  const [selectedActions, setSelectedActions] = useState<string[]>(
    role.permissions,
  );
  const [roleName, setRoleName] = useState<string>(role.roleName);

  return (
    <>
      <div className={styles.modalInputContainer}>
        <TextInput
            name='roleName'
            value={roleName}
            type='text'
            label='Role Name'
            onChange={(event) => setRoleName(event.target.value)}
        />
      </div>
      <SelectPermissions
          selectedActions={selectedActions}
          setSelectedActions={setSelectedActions}
          entities={entities}
          actions={actions}
      />
      <Button
          onClick={() => editRole(role, roleName, selectedActions)}
          variant='primary'
          label='Edit Role'
      />
    </>
  );
}

export default EditRoleModal;
